interface CirclePlusProps {
  width?: number;
  height?: number;
  fillColor?: string;
}

export const CirclePlus = ({ width = 17, height = 17, fillColor = '#7D55C7' }: CirclePlusProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3013_31465)">
        <rect
          width={width}
          height={height}
          transform="translate(0.5 0.5)"
          fill={fillColor}
          fillOpacity="0.01"
        />
        <g clipPath="url(#clip1_3013_31465)">
          <path
            d="M8.49951 15.499C6.643 15.499 4.86252 14.7615 3.54976 13.4488C2.23701 12.136 1.49951 10.3555 1.49951 8.49902C1.49951 6.64251 2.23701 4.86203 3.54976 3.54928C4.86252 2.23652 6.643 1.49902 8.49951 1.49902C10.356 1.49902 12.1365 2.23652 13.4493 3.54928C14.762 4.86203 15.4995 6.64251 15.4995 8.49902C15.4995 10.3555 14.762 12.136 13.4493 13.4488C12.1365 14.7615 10.356 15.499 8.49951 15.499ZM8.49951 16.499C10.6212 16.499 12.6561 15.6562 14.1564 14.1559C15.6567 12.6556 16.4995 10.6208 16.4995 8.49902C16.4995 6.37729 15.6567 4.34246 14.1564 2.84217C12.6561 1.34188 10.6212 0.499023 8.49951 0.499023C6.37778 0.499023 4.34295 1.34188 2.84266 2.84217C1.34237 4.34246 0.499512 6.37729 0.499512 8.49902C0.499512 10.6208 1.34237 12.6556 2.84266 14.1559C4.34295 15.6562 6.37778 16.499 8.49951 16.499Z"
            fill={fillColor}
          />
          <path
            d="M8.49951 4.49902C8.63212 4.49902 8.7593 4.5517 8.85307 4.64547C8.94683 4.73924 8.99951 4.86642 8.99951 4.99902V7.99902H11.9995C12.1321 7.99902 12.2593 8.0517 12.3531 8.14547C12.4468 8.23924 12.4995 8.36642 12.4995 8.49902C12.4995 8.63163 12.4468 8.75881 12.3531 8.85258C12.2593 8.94635 12.1321 8.99902 11.9995 8.99902H8.99951V11.999C8.99951 12.1316 8.94683 12.2588 8.85307 12.3526C8.7593 12.4463 8.63212 12.499 8.49951 12.499C8.3669 12.499 8.23973 12.4463 8.14596 12.3526C8.05219 12.2588 7.99951 12.1316 7.99951 11.999V8.99902H4.99951C4.8669 8.99902 4.73973 8.94635 4.64596 8.85258C4.55219 8.75881 4.49951 8.63163 4.49951 8.49902C4.49951 8.36642 4.55219 8.23924 4.64596 8.14547C4.73973 8.0517 4.8669 7.99902 4.99951 7.99902H7.99951V4.99902C7.99951 4.86642 8.05219 4.73924 8.14596 4.64547C8.23973 4.5517 8.3669 4.49902 8.49951 4.49902Z"
            fill={fillColor}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3013_31465">
          <rect
            width={width}
            height={height}
            fill="white"
            transform="translate(0.5 0.5)"
          />
        </clipPath>
        <clipPath id="clip1_3013_31465">
          <rect
            width={width}
            height={height}
            fill="white"
            transform="translate(0.5 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
